import type { ScheduleRequestBranding } from '@/types/scheduleRequest';
import { normalizeContactPhoneToE164 } from '@/lib/contacts/phone';

export function getBookingContactHref(
  branding: Pick<ScheduleRequestBranding, 'phone' | 'email'>,
): string | null {
  const phone = branding.phone?.trim();
  if (phone) {
    const normalizedPhone = normalizeContactPhoneToE164(phone.replace(/(?!^)\+/g, ''));
    if (normalizedPhone) return `tel:${normalizedPhone}`;
  }

  const email = branding.email?.trim();
  return email ? `mailto:${email}` : null;
}

/**
 * How to name the action behind a contact href. `getBookingContactHref` falls
 * back to `mailto:` when the tenant has no dialable phone, so copy that always
 * said "call us" would point customers at the wrong channel.
 */
export function getBookingContactActionLabel(href: string | null): string {
  if (href?.startsWith('tel:')) return 'call us';
  if (href?.startsWith('mailto:')) return 'email us';
  return 'contact us';
}
